export const env = {
	apiUrl: import.meta.env.VITE_API_URL,
	frontendUrl: import.meta.env.VITE_FRONTEND_URL,
	appUrl: import.meta.env.VITE_APP_URL,
	sentryDsnKey: import.meta.env.VITE_SENTRY_DSN_KEY,
	cloudFrontUrl: import.meta.env.VITE_CLOUDFRONT_URL,
	getWaitListId: import.meta.env.VITE_GET_WAITLIST_ID,
	getWaitListApi: import.meta.env.VITE_GET_WAITLIST_API,
	googleTrackingId: import.meta.env.VITE_GOOGLE_TRACKING_ID
}
